const CommonErrors = {
  NETWORK_ERROR: "Network Error",
};

export default CommonErrors;
